import _get from 'lodash/get';

export function createFormData(data = {}) {
  const serviceDays = _get(data, 'service_days', '');
  const products = _get(data, 'products', []);
  const productVariantIds = _get(data, 'product_variants', []);
  const productTypes = _get(data, 'product_types', []);

  return {
    ...data,
    service_days: `${serviceDays}`,
    products: Array.isArray(products) ? products : [],
    product_variants: Array.isArray(productVariantIds)
      ? [...new Set(productVariantIds)]
      : [],
    product_types: Array.isArray(productTypes) ? productTypes : []
  };
}

export function getProductVariantIds(products = []) {
  const ids = products.reduce((acc, product) => {
    const productVariants = _get(product, 'productVariants', []);
    const ids = productVariants.map(({ objectID }) => objectID);
    return acc.concat(ids);
  }, []);
  return [...new Set(ids)];
}

/**
 * @param {import('zod').infer<typeof import("./stubs").FORM_SCHEMA>} data
 * @param {keyof typeof import("../stubs").PRODUCT_WINDOW_TYPE} windowType
 * */
export function createPayload(data = {}, windowType = 'SKU') {
  const { service_days: serviceDays, products, ...restData } = data;

  const payload = {
    ...restData,
    service_days: +serviceDays
  };

  // Clean up: remove the field we're not using
  if (windowType === 'SKU') {
    delete payload.product_types;
  } else {
    delete payload.product_variants;
  }

  return payload;
}

export function getProductTypeIds(productTypes = []) {
  return productTypes
    .map(productType => _get(productType, 'id', ''))
    .filter(Boolean);
}
